const HIGHLIGHT_COLOR = '#fff454'

export default {
    data() {
        return {
            isRowHighlighted: false,
        }
    },
    methods: {
        highlightRow() {
            if (this.isRowHighlighted) {
                this.$set(this, 'isRowHighlighted', false)
            } else {
                this.$set(this, 'isRowHighlighted', true)
            }
        },
    },
    computed: {
        highlightColor() {
            return this.isRowHighlighted ? HIGHLIGHT_COLOR : ''
        },
    },
}
